import { addDays, startOfDay } from "date-fns";

// Get current date/time in Eastern Time (handles EST/EDT automatically)
const getESTDate = () => {
    // Get the current date parts in America/New_York timezone
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    });

    const parts = formatter.formatToParts(new Date());
    const get = (type) => parts.find(p => p.type === type)?.value;

    // Create a date object with the EST date/time values
    return new Date(
        parseInt(get('year')),
        parseInt(get('month')) - 1,  // months are 0-indexed
        parseInt(get('day')),
        parseInt(get('hour')),
        parseInt(get('minute')),
        parseInt(get('second'))
    );
};

// Get today's date in EST timezone
export const getToday = () => startOfDay(getESTDate());

// Get the next puzzle date (tomorrow)
export const getNextPuzzleDate = (date) =>
    addDays(startOfDay(date ?? getToday()), 1);
